import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './FunctionalDeficits.module.css';
import { AddButton } from '_components';
import { PatientCareCenterNoteSubjectiveFunctionalDeficitEntryWC } from './FunctionalDeficitEntryWC';
import { PatientCareCenterNoteSubjectiveFunctionalDeficitEntryCustomWC } from './FunctionalDeficitEntryCustomWC';
import { RefManager } from '_helpers';


class PatientCareCenterNoteSubjectiveFunctionalDeficitsWC extends React.Component {


    addFuncDef() {
        this.props.addChildRow(this.props.noteId, 'PTGOALS', 'GO', 'GOEVNO', this.props.evno);
    }

    addFuncDefCustom() {
        this.props.addCustomGoal(this.props.noteId, true);
    }


    render() {
        if (!this.props.pdc) {
            return (
                <PatientCareCenterNoteSection id='sub_med_hist_func_deficits' name='Work Deficits' level={2} allowCollapse={true} >
                    <span className={styles.pdc_warning}>
                        The patient's Job Required PDC level has not yet been determined in the Subjective section of the note.  This section must be completed prior to
                        adding functional deficits.  <span className={styles.pdc_link} onClick={() => RefManager.scrollToRef('subj_wc')}>Click here</span> to enter the PDC criteria.
                    </span>
                </PatientCareCenterNoteSection>
            );
        } else {

            return (
                <PatientCareCenterNoteSection id='sub_med_hist_func_deficits' name='Work Deficits' level={2} allowCollapse={true} >
                    <div>
                        <div className={styles.row}>
                            <div className={styles.add_button} >
                                <AddButton title='Add Work Deficit...' size='extra-small' onClick={() => this.addFuncDef()} />
                            </div>
                            <span>
                                <div className={styles.column_1_header}>Work Activity</div>
                                <div className={styles.column_2_header}>PLOF</div>
                                <div className={styles.column_3_header}>CLOF</div>
                                <div className={styles.column_4_header}>Goal</div>
                                <span className={styles.remove_button} />
                            </span>
                        </div>
                        {Object.keys(this.props.funcDefEntries)
                            .map(key => {
                                const result = this.props.funcDefEntries[key];
                                return (
                                    <PatientCareCenterNoteSubjectiveFunctionalDeficitEntryWC key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>
                    <div>
                        <div className={styles.row}>
                            <div className={styles.add_button} >
                                <AddButton title='Add Custom Work Deficit...' size='extra-small' onClick={() => this.addFuncDefCustom()} />
                            </div>
                            <span>
                                <div className={styles.column_1_header}>Custom Work Activity</div>
                                <div className={styles.column_2_header}>PLOF</div>
                                <div className={styles.column_3_header}>CLOF</div>
                                <div className={styles.column_4_header}>Goal</div>
                                <span className={styles.remove_button} />
                            </span>
                        </div>
                        {Object.keys(this.props.funcDefEntriesCustom)
                            .map(key => {
                                const result = this.props.funcDefEntriesCustom[key];
                                return (
                                    <PatientCareCenterNoteSubjectiveFunctionalDeficitEntryCustomWC key={result.GONO} id={result.GONO} />
                                )
                            })
                        }
                    </div>
                </PatientCareCenterNoteSection>
            );
        }
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addChildRow: bindActionCreators(noteActions.addChildRow, dispatch),
        addCustomGoal: bindActionCreators(noteActions.addCustomGoal, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let evno = parseInt(noteId.split("_")[1]);
    let epno = state.entities.notes.PTEVAL[evno].EVEPNO;

    let funcDefEntries = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return state.entities.notes.PTGOALS[key].GOEVNO === evno
                && state.entities.notes.PTGOALS[key].GODELETED !== true
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_IND_HEP_GOAL_ID'].PRVALUE)
                && state.entities.notes.PTGOALS[key].GOMGNO !== parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE)
        })
        .sort((a, b) => state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO)
        .map(key => state.entities.notes.PTGOALS[key]);

    let funcDefEntriesCustom = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => {
            return state.entities.notes.PTGOALS[key].GOEVNO === evno
                && state.entities.notes.PTGOALS[key].GODELETED !== true
                && state.entities.notes.PTGOALS[key].GOMGNO === parseInt(state.entities.masterData.PROPS['PTERO_CUSTOM_GOAL_ID_WC'].PRVALUE)
        })
        .sort((a, b) => state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO)
        .map(key => state.entities.notes.PTGOALS[key]);

    let pdc = undefined;
    if (state.entities.notes.PTEVAL[evno].EVSUBWCJOBREQPDC) {
        pdc = state.entities.notes.PTEVAL[evno].EVSUBWCJOBREQPDC;
    } else {
        pdc = state.entities.admissions[epno].jobReqPdc;
    }

    return {
        noteId,
        evno,
        funcDefEntries,
        funcDefEntriesCustom,
        pdc,
    }
}
const connectedPatientCareCenterNoteSubjectiveFunctionalDeficitsWC = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveFunctionalDeficitsWC);
export { connectedPatientCareCenterNoteSubjectiveFunctionalDeficitsWC as PatientCareCenterNoteSubjectiveFunctionalDeficitsWC };

